import { useQuery } from '@tanstack/react-query';

import { LevelService } from '../services/level';

export function useGetLevel(levelPosition: string | null) {
  const { data, error, isFetching, isLoading, isError } = useQuery(['level', levelPosition], () =>
    LevelService.getLevelWithUnits(levelPosition),
  );

  return {
    data: data?.data,
    error,
    isFetching,
    isLoading,
    isError,
  };
}
